import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Menu from './Menu'; 
import ML from './images/ML_alfa_edt.png';
import Ministere from './images/Ministere_extraido.png';

import './Layout.css'; 

const Layout = () => {
  const [expandido, setExpandido] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => setExpandido(false), 3000);
  
      const handleClick = () => {
        setExpandido(false);
      };
      window.addEventListener("click", handleClick);

      return () => {
        clearTimeout(timer);
        window.removeEventListener("click", handleClick);
      };
    }, []);

    const footer = expandido ? "footer grande" : "footer";

   



  return (
    <div className="layout">
      <Menu/>
       <Outlet /> 

<footer className={footer}>
   {expandido ? ( 
              
            <div className='grid-footer-container'>

          <div className="footer-mini">
              <div className='grid-footer-container'>
          <div className='grid-item-logo' id='grid1-logo'>
          <img src={ML} alt="ML" className='footer-logo' />

          </div>

          <div className='grid-item-logo' id='grid2-logo'>
          <img src={Ministere} alt="Ministere" className='footer-ministere' />

          </div>
                      </div>
                      </div>

          </div>
          ) : ( null  )}
  
      </footer>
    </div>
  );
};

export default Layout;